import { findObjectStartsWithKey, useDracoGLTF } from "@utils";
import { Ebbne, MountWithEbbne, useEbbne } from "@solidwhite/ebbnen";
import SetCameraTarget from "../../SetCameraTarget";
import EbbnenLabel from "../../EbbnenLabel";
import { MarkerLabels } from "@ui/MarkerLabel";
import React, { useEffect, useMemo, useRef } from "react";
import { Labels } from "@ui/Labels";
import VisibleWithEbbne from "../../VisibleWithEbbne";
import { UIPortal } from "@solidwhite/ui-portal";
import SideBar from "@ui/SideBar/SideBar";
import { PulsingMaterial } from "../../materials/PulsingMaterial";
import { useFrame } from "@react-three/fiber";
import { Vector3, Vector4 } from "three";

import { useRemapMaterials } from "../../Materials";

const WeldacSystem = () => {
  const { scene, nodes } = useDracoGLTF("./models/heat/Weldac_System.glb");

  useRemapMaterials(scene);

  const labelNodes = findObjectStartsWithKey("Labels", scene);
  const markerNodes = findObjectStartsWithKey("Markers", scene);

  const [material1, material2, material3, material4, material5] = useMemo(() => {
    const material1 = PulsingMaterial({
      colorA: new Vector4(0, 0.4, 1, 1),
      colorB: new Vector4(0, 0.2, 1, 1),
      speed: 0.2,
      spacing: 0.2,
    });
    nodes["Curve_2"].material = material1;

    const material2 = PulsingMaterial({
      colorA: new Vector4(0, 0.4, 1, 1),
      colorB: new Vector4(0, 0.2, 1, 1),
      speed: -0.2,
      spacing: 0.2,
    });
    nodes["Curve_3"].material = material2;

    const material3 = PulsingMaterial({
      colorA: new Vector4(1, 0.3, 0, 1),
      colorB: new Vector4(1, 1, 0, 1),
      blend: 0.5,
      sharpness: 10,
      spacing: 0.05,
    });
    nodes["Curve_4"].material = material3;

    const material4 = PulsingMaterial({
      colorA: new Vector4(0.27, 0.62, 0.34, 0.2),
      colorB: new Vector4(0.37, 0.72, 0.44, 1),
      speed: -0.7,
      spacing: 0.5,
      sharpness: 10,
      blend: 1,
      uEmissiveB: new Vector3(0.27, 0.62, 0.34),
      uEmissiveIntensityB: 6,
    });
    nodes["Curve_1"].material = material4;

    const material5 = PulsingMaterial({
      colorA: new Vector4(1, 0.3, 0, 1),
      colorB: new Vector4(1, 1, 0, 1),
      blend: 0.5,
      sharpness: 10,
      spacing: 0.05,
    });
    nodes["Curve_5"].material = material5;

    return [material1, material2, material3, material4, material5];
  }, []);

  useFrame(({ clock }) => {
    material1.uniforms.uTime.value = clock.elapsedTime;
    material2.uniforms.uTime.value = clock.elapsedTime;
    material3.uniforms.uTime.value = clock.elapsedTime;
    material4.uniforms.uTime.value = clock.elapsedTime;
    material5.uniforms.uTime.value = clock.elapsedTime;
  });

  return (
    <>
      <VisibleWithEbbne visibleWhen={"visible"}>
        <primitive object={scene}></primitive>
      </VisibleWithEbbne>

      <MountWithEbbne>
        <VisibleWithEbbne visibleWhen={"visible-and-below"}></VisibleWithEbbne>
        <MarkerLabels node={markerNodes}></MarkerLabels>
        <Labels data={labelNodes.children}></Labels>

        <SetCameraTarget settingsObject={findObjectStartsWithKey("CameraTarget_main", scene)} />

        <UIPortal>
          <SideBar key={`Sidebar_weldac-system-overview`} contentId={"weldac-system-overview"} />
        </UIPortal>
      </MountWithEbbne>

      {labelNodes.children.map((node) => {
        const name = node.userData.targetId.replace("./", "");

        return (
          <Ebbne id={name} key={name}>
            <MountWithEbbne>
              <SetCameraTarget settingsObject={findObjectStartsWithKey(`CameraTarget_${name}`, scene)} />
              <UIPortal>
                <SideBar key={name} contentId={name} />
              </UIPortal>
            </MountWithEbbne>
          </Ebbne>
        );
      })}
    </>
  );
};
export default WeldacSystem;

useDracoGLTF.preload("./models/heat/Weldac_System.glb");
